export const NETWORK_TYPE_VALUES = ['TT', 'TN', 'TN-CS', 'TN-C', 'TN-S'] as const;
export type NetworkType = typeof NETWORK_TYPE_VALUES[number];
export interface NetworkTypeAnswer { networkType: NetworkType }
export const NETWORK_TYPE_OPTIONS = NETWORK_TYPE_VALUES.map((value) => ({ value, label: value }));

export const isNetworkType = (value: unknown): value is NetworkType =>
  typeof value === 'string' && NETWORK_TYPE_VALUES.some((option) => option === value);

export const getNetworkTypeValue = (answer: unknown): NetworkType | undefined => {
  if (!answer || typeof answer !== 'object' || Array.isArray(answer)) return undefined;
  const value = (answer as Record<string, unknown>).networkType;
  return isNetworkType(value) ? value : undefined;
};

export const toNetworkTypeAnswer = (value: unknown): NetworkTypeAnswer | undefined =>
  isNetworkType(value) ? { networkType: value } : undefined;
